<template>
  <div class="flex justify-content-center">
    <MultiSelect
      v-model="currentSelectedItems"
      display="chip"
      :options="options ?? []"
      optionLabel="name"
      :placeholder="placeholder"
      :class="inputClass"
      @change="onChange"
    >
      <template #header>
        <!-- Use the header to put the custom label - MultiSelect does not have option to add custom label for select all check box -->
        <div @click="customHeaderClicked" class="custom-header">{{ selectAllLabel ?? 'All' }}</div>
      </template>
    </MultiSelect>
  </div>
</template>

<script>
import MultiSelect from 'primevue/multiselect';

export default {
  name: 'ChipInput',
  components: {
    MultiSelect,
  },
  props: ['selectedItems', 'options', 'placeholder', 'inputClass', 'selectAllLabel'],
  data() {
    return {
      currentSelectedItems: [],
    };
  },
  methods: {
    customHeaderClicked() {
      if (this.currentSelectedItems.length !== this.options.length) {
        this.currentSelectedItems = this.options.map((item) => {
          return {
            name: item.name,
            code: item.code,
          };
        });
      } else {
        this.currentSelectedItems = [];
      }
      this.$emit('change', this.currentSelectedItems);
    },
    onChange(data) {
      this.$emit('change', data.value);
    },
  },
  mounted() {
    this.currentSelectedItems = this.selectedItems;
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/global.scss';
.custom-header {
  position: absolute;
  margin-left: 2.75rem;
  margin-top: 0.75rem;
  cursor: pointer;
}

.p-multiselect:not(.p-disabled).p-focus {
  border-color: rgba($light-text-color, 0.15);
  box-shadow: 0 0 0 0.13rem rgba($light-text-color, 0.15) !important;
}

.p-multiselect:not(.p-disabled):hover {
  border-color: rgba($light-text-color, 0.15) !important;
}

:deep(.p-multiselect-token) {
  background-color: rgba($primary-button-text-color-fixed, 0.1) !important;
  border-radius: 4px !important;
  margin-right: 0.3rem !important;
}

:deep(.p-multiselect-label) {
  padding: 0.25rem 0.3rem !important;
}

:deep(.p-placeholder) {
  height: 40px !important;
  display: flex;
  align-items: center;
  margin-left: 0.3rem;
}
</style>
